import React from "react";
import { useEffect, useState } from "react";
import { firestore } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import "../scss/Scss/Home.scss";
import { Link } from "react-router-dom";

function ProjectsPage() {
  const [dataCIWEB, setDataCIWEB] = useState(null);
  const [dataCISafetyEdit, setDataCISafetyEdit] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const docRefCIWEB = doc(firestore, "CI WEB", "Home");
    const docRefCISafetyEdit = doc(firestore, "CI WEB - SAFETY EDIT", "Home");

    const fetchDataCIWEB = async () => {
      try {
        const docSnapshot = await getDoc(docRefCIWEB);
        if (docSnapshot.exists()) {
          setDataCIWEB(docSnapshot.data());
        } else {
          console.log("No such document for CI WEB!");
        }
      } catch (error) {
        console.error("Error fetching document for CI WEB:", error);
      }
    };

    const fetchDataCISafetyEdit = async () => {
      try {
        const docSnapshot = await getDoc(docRefCISafetyEdit);
        if (docSnapshot.exists()) {
          setDataCISafetyEdit(docSnapshot.data());
        } else {
          console.log("No such document for CI WEB - SAFETY EDIT!");
        }
      } catch (error) {
        console.error(
          "Error fetching document for CI WEB - SAFETY EDIT:",
          error
        );
      }
    };

    fetchDataCIWEB();
    fetchDataCISafetyEdit();

    setIsMobile(window.innerWidth <= 1366);
    window.addEventListener("resize", () => {
      setIsMobile(window.innerWidth <= 1366);
    });

    return () => {
      window.removeEventListener("resize", () => {
        setIsMobile(window.innerWidth <= 1366);
      });
    };
  }, []);

  return (
    <>
      {dataCIWEB && dataCISafetyEdit && (
        <div className={`Home-Projects ${isMobile ? "Home-ProjectsMB" : ""}`}>
          {!isMobile ? (
            <div className="Subheading-Projects">
              <div className="text-SubheadingProjects">
                {dataCISafetyEdit.ServiceSubheading1}
                <br />
                {dataCISafetyEdit.ServiceSubheading2}
                <br />
                {dataCISafetyEdit.ServiceSubheading3}
              </div>
              <div
                style={{
                  background: "black",
                  width: "30rem",
                  height: "6rem",
                }}
              ></div>
              <div className="HeadBtn-Projects">
                <Link to="/projects" className="BtnProjects">
                  PROJECTS
                </Link>
                <Link to="/service" className="BtnServices">
                  SERVICES
                </Link>
              </div>
            </div>
          ) : (
            <div className="AllTextBtnsProject">
              <div className="Subheading-ProjectsMB">
                <div className="text-SubheadingProjectsMB">
                  <div>{dataCISafetyEdit.ServiceSubheading1}</div>
                  <div>{dataCISafetyEdit.ServiceSubheading2}</div>
                  <div>{dataCISafetyEdit.ServiceSubheading3}</div>
                </div>
                <div className="HeadBtn-ProjectsMB">
                  <Link to="/projects" className="BtnProjectsMB">
                    PROJECTS
                  </Link>
                  <Link to="/service" className="BtnServicesMB">
                    SERVICES
                  </Link>
                </div>
              </div>
            </div>
          )}

          {!isMobile ? (
            <video
              loop
              muted
              autoPlay
              playsInline
              className="BgVideoProjects"
              style={{ pointerEvents: "auto" }}
              onContextMenu={(e) => e.preventDefault()}
            >
              <source
                src={dataCISafetyEdit.CIWEBHOMEPROJECTSNOTEXT}
                type="video/mp4"
              />
            </video>
          ) : (
            <div
              style={{
                height: "auto",
                width: "100%",
                borderRadius: "2rem",
              }}
            >
              <div
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                }}
              >
                <video
                  loop
                  muted
                  autoPlay
                  playsInline
                  className="BgVideoProjectsMB"
                  style={{ pointerEvents: "auto" }}
                  onContextMenu={(e) => e.preventDefault()}
                >
                  <source
                    src={dataCISafetyEdit.CIWEBHOMEPROJECTSNOTEXTMOBILE}
                    alt="Video BGProject"
                  />
                </video>
              </div>
            </div>
          )}

          {!isMobile ? (
            <div className="DescriptionProjects">
              <span className="text-DescriptionProjects">
                {dataCISafetyEdit.ServiceDescription}
              </span>
            </div>
          ) : (
            <div className="DescriptionProjectsMB">
              <p className="text-DescriptionProjectsMB">
                {dataCISafetyEdit.ServiceDescription}
              </p>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default ProjectsPage;
